import React, { useEffect, useRef } from 'react';

/**
 * ScrollIndicator — thin reading-progress bar under the fixed navbar.
 * Uses transform: scaleX driven by rAF-throttled scroll (no layout thrash).
 */
const ScrollIndicator = ({ offset = 72 }) => {
    const barRef = useRef(null);

    useEffect(() => {
        let ticking = false;
        const update = () => {
            const doc = document.documentElement;
            const max = doc.scrollHeight - window.innerHeight;
            const progress = max > 0 ? Math.min(window.scrollY / max, 1) : 0;
            if (barRef.current) {
                barRef.current.style.transform = `scaleX(${progress})`;
            }
            ticking = false;
        };
        const onScroll = () => {
            if (!ticking) {
                ticking = true;
                requestAnimationFrame(update);
            }
        };
        update();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onScroll);
        };
    }, []);

    return (
        <div
            aria-hidden="true"
            className="fixed inset-x-0 h-[3px] z-[999] pointer-events-none"
            style={{ top: `${offset}px` }}
        >
            <div
                ref={barRef}
                className="h-full w-full origin-left rtl:origin-right bg-gradient-to-r from-primary to-secondary"
                style={{ transform: 'scaleX(0)' }}
            />
        </div>
    );
};

export default ScrollIndicator;
